import { useMediaQuery } from '@ori-ui/mui';
export const useIsMobile = ({
  options
} = {}) => useMediaQuery(theme => theme.breakpoints.down('sm'), options);
//# sourceMappingURL=useIsMobile.js.map